export default {
  "fr": {
    "issue_category": {
      "labels": {
        "category_name": "Nom de la catégorie",
        "integration_warning": "Une intégration avec le module After care de votre plateforme est active. Si vous souhaitez créer ou modifier des catégories, veuillez nous contacter.",
        "new_category": "Nouvelle catégorie de problème"
      }
    }
  }
}